'use es6';

import { tryParseNumber } from 'DesignData/lib/text';
import Tab from 'DesignData/models/Tab';
import { userPortal as userPortalLocalStorage, tryConvertLegacyStorage } from 'DesignData/lib/localStorage';
import { DESIGN_MANAGER_TABS } from 'DesignData/enums/attributes/UserPortal';
const legacyKeySuffix = 'designbrowser:tabs';

const convertId = id => tryParseNumber(/:(.+)/.exec(id)[1]);

function convertToNewId(__data) {
  const data = {};

  if (__data.activeTabId) {
    data.activeTabId = convertId(__data.activeTabId);
  }

  data.byId = __data.order.reduce((byId, tabId) => {
    const __tab = __data.byId[tabId];
    const tab = new Tab({
      id: __tab.assetId,
      label: __tab.label,
      path: __tab.path,
      assetType: __tab.assetType
    });
    byId[tab.id] = tab;
    return byId;
  }, {});
  data.order = __data.order.map(convertId);
  data.converted = true;
  return data;
}
/**
 *
 * @param {Number} userId
 * @param {Number} portalId
 * @returns {Object|Null}
 */


export function fetch(userId, portalId) {
  const storageClient = userPortalLocalStorage(userId, portalId, DESIGN_MANAGER_TABS);
  let data = tryConvertLegacyStorage(storageClient, legacyKeySuffix, {
    async: false
  }) || storageClient.fetch();

  if (data && !data.converted) {
    data = convertToNewId(data);
  }

  return data;
}
/**
 *
 * @param {Number} userId
 * @param {Number} portalId
 * @param {Object} data
 * @returns {Promise}
 */

export function save(userId, portalId, data) {
  const storageClient = userPortalLocalStorage(userId, portalId, DESIGN_MANAGER_TABS);

  if (data.converted !== true) {
    data = Object.assign({}, data, {
      converted: true
    });
  }

  return storageClient.saveAsync(data);
}